import React from 'react';

import {
    Chart as ChartJS,
    CategoryScale,
    RadialLinearScale,
    LinearScale,
    PointElement,
    LineElement,
    Filler,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Title,
    Tooltip,
    Legend
);

// Define the mapping from chart labels to CORRECT backend attribute keys for outfield players
const chartAttributeMapping = {
    'Defensive Awareness': 'Defensive Awareness Score',
    'Ball Winning Ability': 'Ball Winning Score',
    'Passing': 'Buildup Passing Score', // Using the actual backend key
    'Creativity': 'Creativity Score',
    'Finishing': 'Finishing Score',
    'Crossing': 'Crossing Score',
    'Dribbling': 'Dribbling Score',
    'Aerial Ability': 'Aerial Ability Score'
};

// Order matters for the chart labels (outfield)
const chartLabelsInOrder = [
    'Defensive Awareness',
    'Ball Winning Ability',
    'Passing',
    'Creativity',
    'Finishing',
    'Crossing',
    'Dribbling',
    'Aerial Ability'
];

// Goalkeeper attributes for polar chart
const goalkeeperAttributeMapping = {
    'Aggressiveness': 'Goalkeeper Aggressiveness Score',
    'Passing Ability': 'Goalkeeper Passing Ability Score',
    'Shot Stopping': 'Goalkeeper Shot Stopping Score'
};

const goalkeeperLabelsInOrder = [
    'Aggressiveness',
    'Passing Ability', 
    'Shot Stopping'
];

const PlayerChart = ({ props: stats, role }) => {
    // Handle empty state
    if (!stats || Object.keys(stats).length === 0) {
        return (
            <div className="empty-state">
                <p>No player attributes available for chart.</p>
            </div>
        );
    }

    // Determine if this is a goalkeeper
    const isGoalkeeper = role === 'GK';

    // Determine labels and data source based on role
    const labels = isGoalkeeper ? goalkeeperLabelsInOrder : chartLabelsInOrder;
    const attributeMapping = isGoalkeeper ? goalkeeperAttributeMapping : chartAttributeMapping;

    const dataStats = labels.map(label => {
        const backendKey = attributeMapping[label];
        const value = stats[backendKey];
        return (typeof value === 'number') ? value : 50; 
    });

    const data = {
        labels: labels,
        datasets: [
            {
                label: '',
                data: dataStats,
                fill: true,
                backgroundColor: 'rgba(123, 250, 198, 0.2)',
                borderColor: 'rgb(123, 250, 198)',
                pointBackgroundColor: 'rgb(123, 250, 198)',
                pointBorderColor: 'rgb(123, 250, 198)',
                pointHoverBackgroundColor: 'rgb(123, 250, 198)',
                pointBorderWidth: 1,
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
                labels: {
                    fontSize: 0
                }
            },
        },
        scales: {
            y: {
                display: false
            },
            r: {
                suggestedMax: 100,
                suggestedMin: 0,
                angleLines: {
                    color: '#ffffff'
                },
                grid: {
                    color: '#ffffff',
                    circular: true
                },
                pointLabels: {
                    color: '#ffffff',
                    font: {
                        size: 12
                    }
                },
                ticks: {
                    stepSize: 20,
                    color: '#ffffff',
                    backdropColor: '#121529',
                    font: {
                        size: 12
                    }
                }
            }
        }
    };

    return <Radar data={data} options={options} />;
};

export { PlayerChart }
